import { render, staticRenderFns } from "./PendingCdrsTab.vue?vue&type=template&id=3432b4f9&scoped=true"
import script from "./PendingCdrsTab.vue?vue&type=script&lang=js"
export * from "./PendingCdrsTab.vue?vue&type=script&lang=js"
import style0 from "./PendingCdrsTab.vue?vue&type=style&index=0&id=3432b4f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3432b4f9",
  null
  
)

export default component.exports